// extracted by mini-css-extract-plugin
export var container = "TakeOver-module--container--2af71";
export var containerClosed = "TakeOver-module--container--closed--9ea64";
export var containerOpen = "TakeOver-module--container--open--71b80";
export var header = "TakeOver-module--header--71785";
export var headerTitle = "TakeOver-module--header-title--45101";
export var innerContainer = "TakeOver-module--inner-container--7077c";
export var innerHeaderContainer = "TakeOver-module--inner-header-container--c8b82";
export var leftArrow = "TakeOver-module--left-arrow--c9a41";
export var rightSideHeaderComponent = "TakeOver-module--right-side-header-component--24697";